import { loadingBarMiddleware } from 'react-redux-loading-bar'
import { applyMiddleware, createStore, compose } from 'redux'
import axiosMiddleware from 'redux-axios-middleware'
import thunk from 'redux-thunk'
import AxiosConfig from '../shared/infra/http/AxiosConfig'
import rootReducer from './root.reducer'

export default function configureStore(router, initialState) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  return createStore(
    rootReducer,
    initialState,
    composeEnhancers(
      applyMiddleware(
        thunk,
        axiosMiddleware(AxiosConfig.AxiosClient, AxiosConfig.MiddlewareConfig),
        loadingBarMiddleware({
          promiseTypeSuffixes: ['REQUEST', 'SUCCESS', 'FAIL']
        })
      )
    )
  )
}



// WEBPACK FOOTER //
// ./src/redux/config.store.js